import { Button } from "../base";
import { Accordion } from "../base";
import { motion } from "framer-motion";

export function FaqSection({ id, title, description, buttons, faqs, ...rest }) {
    return (
        <section
            id={id}
            className="py-24 bg-gradient-to-b from-cyan-100/90 to-white dark:from-base-900 dark:to-base-950"
            {...rest}
        >
            <div className="container max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    {/* Left: heading */}
                    <div className="lg:col-span-5 self-start">
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                            className="flex flex-col items-start text-left gap-5 lg:sticky lg:top-24"
                        >
                            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-display text-title dark:text-white font-medium leading-tight">
                                Tentang
                                <br />
                                Sistem
                                <br />
                                Antrian Kami
                            </h2>
                            <p className="text-muted dark:text-base-400 text-base max-w-sm font-body">
                                {description}
                            </p>
                            {buttons && buttons.length > 0 && (
                                <div className="flex flex-wrap gap-4 mt-2">
                                    {buttons.map((button, index) => (
                                        <Button key={index} {...button} />
                                    ))}
                                </div>
                            )}
                        </motion.div>
                    </div>

                    {/* Right: accordion */}
                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{
                            duration: 0.6,
                            delay: 0.15,
                            ease: "easeOut",
                        }}
                        className="lg:col-span-7"
                    >
                        <Accordion items={faqs} />
                    </motion.div>
                </div>
            </div>
        </section>
    );
}